import React from "react";
import FormModal from "../../../../components/modals/FormModal";
import { FormLayout, FormRow } from "../../../../components/layout/forms/Index";
import Button from "../../../../components/buttons/Button";

export default function TalentModal({
  title,
  description,
  busy,
  onClose,
  onSave,
  children,
  saveLabel = "Save",
}) {
  return (
    <FormModal
      isOpen
      onClose={onClose}
      loading={busy}
      closeOnEscape={false}
      closeOnOverlay={false}
      maxWidth={600}
    >
      <FormLayout title={title} description={description}>
        {children}
        <FormRow style={{ marginTop: "1.5rem" }}>
          <Button
            variant="primary-outlined"
            value="Cancel"
            disabled={busy}
            onClick={onClose}
          />
          <Button
            variant="primary"
            value={busy ? "Saving..." : saveLabel}
            disabled={busy}
            onClick={onSave}
          />
        </FormRow>
      </FormLayout>
    </FormModal>
  );
}
